export default "__VITE_ASSET__c7c1c956__"